import {defineMessages} from 'react-intl.macro';

export const messages = defineMessages({
  'checkpointType.form.description': {
    defaultMessage: 'Description',
    id: 'checkpointType.form.description'
  },
  'checkpointType.form.heading': {
    defaultMessage: 'Checkpoint Type',
    id: 'checkpointType.form.heading'
  },
  'checkpointType.form.name': {
    defaultMessage: 'Name',
    id: 'checkpointType.form.name'
  }
});
